import React from 'react';
import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import { Input } from 'src/components/elements/Input';

import styles from './TextField.scss';

type TextFieldProps<T extends FieldValues = FieldValues> = React.ComponentPropsWithoutRef<
  typeof Input
> &
  UseControllerProps<T>;

export const TextField = <T extends FieldValues = FieldValues>({
  name,
  control,
  rules,
  variant,
  defaultValue,
  ...props
}: TextFieldProps<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control, rules, defaultValue });

  return (
    <label className={styles.field}>
      <Input className={styles.input} {...props} {...field} variant={error ? 'danger' : variant} />

      {error && <small className={styles.fieldError}>{error.message}</small>}
    </label>
  );
};
